import Modal from '../../components/ui/Modal'
import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import Banner from '../../components/ui/Banner'
/*
import axios from 'axios'
import ReactGA from 'react-ga4'
import Button from '../../components/ui/Button'
*/

const CharacterPoll = () => {

    useEffect(()=>{
        const date = new Date(localStorage.getItem('dateVoted-round3'))
        const currentDate = new Date()
        if(currentDate.getDate()-date.getDate() < 7) {
            setEligibility(false)
        }
        if(localStorage.getItem('dateVoted-round3') === null) {
            setEligibility(true)
        }
    })


    /*
    const [email, setEmail] = useState("")
    const [name, setName] = useState("")

    const [page, setPage] = useState(0)
    const nextPage = () => {
        page < 2 ? setPage(page+1) : setPage(2)
    }
    const prevPage = () => {
        page > 0 ? setPage(page-1) : setPage(0)
    }

    const [first, setFirst] = useState("")
    const [second, setSecond] = useState("")
    const [third, setThird] = useState("")
    const [fourth, setFourth] = useState("")

    const [wait, setWait] = useState(false)
    const [thanks, showThanks] = useState(false)

    */
   
    const [canVote, setEligibility] = useState(false)

    /*
    const vote = () => {
        if(canVote){
            axios.post("https://mds.nisamerica.com/contest-api/zero-poll-round-3",{
              dataObj: {
                  first: first,
                  second: second,
                  third: third,
                  fourth: fourth,
                  name: name,
                  email: email
              },
              img: ""
            })
            .then ((response)=>{
              console.log(response)
            }, (error) => {
              console.log(error)
            })
          setEligibility(false)
          localStorage.setItem('dateVoted-round3', new Date())
        }
    }
    */

    return (
        <div className="page-container">
            <div className="contest-logo">
                <img src="../img/plain-logo.webp" alt="Disgaea 6 Complete Logo" />
                <h1 className="contest-title">
                    Character Poll
                </h1>
            </div>
            
            <CharacterBracket/>

            {
                /*
                            <div className="line-container" style={{minHeight: "700px", justifyContent: "center"}}>
                            {
                                page === 0 ? <Start/> :
                                page === 1 ? <First setVote={setFirst} setPage={setPage} page={page}/> :
                                page === 2 ? <Fifth canVote={canVote} showThanks={showThanks} vote={vote} setEmail={setEmail} setName={setName} setWait={setWait}/> : "404"
                            }
                            <div className="button-list">
                                {
                                    page > 0 && 
                                    <Button 
                                        text="previous"
                                        type="gradient"
                                        color=""
                                        onClick={()=>{
                                            prevPage()
                                        }}
                                    />
                                }
                                {
                                    page < 2 &&
                                    <Button 
                                        text="next"
                                        type="gradient"
                                        color=""
                                        onClick={()=>{
                                            nextPage()
                                        }}
                                    />
                                }
                            </div>
                        </div>
                        */
            }

            <Link className='version-label' to='/products' style={{width: '100%'}}>
                <Banner
                    text="Available Now!"
                    image={`${process.env.PUBLIC_URL}/img/bg/tech-bg.webp`}
                    position='50% 55%'
                />
            </Link>
       </div>  
    )
}

const CharacterBracket = () => {
    return (
        <section className="character-tree">
            <Modal component={<img src={`${process.env.PUBLIC_URL}/img/final-bracket.webp`} alt="Trails from Zero Character Tree" className="character-tree_image"/>}>
                <div className="tree-preview">
                    <img src={`${process.env.PUBLIC_URL}/img/bracket-final.webp`} alt="Trails from Zero Character Tree" />
                </div>
            </Modal>            
        </section>
    )
}

/*
const Start = () => {
    return (
        <div className="contest-info">
            <div className="info-wrapper">
                <div className="info-spacing">
                    <p>
                        Vote for your favorite <span className="italic">
                        Trails From Zero</span> character for a chance to win a <span className="italic">The Legend of Heroes: Trails from Zero</span> "In Good Company" 1000-piece Puzzle
                    </p>
                    <br/>
                    <p>
                        Voting for each round will take place every Wednesday (May 18th, May 25th and June 1st) starting May 18th. The bracket will be updated every Wednesday. You are allowed to vote only once each round. The final round of voting will take place June 1st.
                    </p>
                    <br/>
                    <p>
                        Once you've selected all the characters you'd like to vote for, you'll be able to submit your votes.
                    </p>
                    <img src={`${process.env.PUBLIC_URL}/img/products/puzzle.webp`} alt="" />
                </div>
            </div>
        </div>
    )
}

const First = ({setVote, setPage, page}) => {
    return (
        <div className="voting-section">
            <h1 style={{width: "100%", textAlign: "center"}}>PICK ONE</h1>
            <div className="vote-pair">
                <img src={`${process.env.PUBLIC_URL}/img/characters/randy.webp`} alt="Randy Key Art" />
                <Button text="Randy" type="solid" onClick={()=>{
                    setVote("Randy")
                    page < 5 ? setPage(page+1) : setPage(5)
                }}/>
            </div>
            <div className="vote-pair">
                <img src={`${process.env.PUBLIC_URL}/img/characters/tio.webp`} alt="Tio Key Art" />
                <Button text="Tio" type="solid" onClick={()=>{
                    setVote("Tio")
                    page < 5 ? setPage(page+1) : setPage(5)
                }}/>
            </div>
            <div className="vote-pair">
                <img src={`${process.env.PUBLIC_URL}/img/characters/kea.webp`} alt="KeA Key Art" />
                <Button text="KeA" type="solid" onClick={()=>{
                    setVote("KeA")
                    page < 5 ? setPage(page+1) : setPage(5)
                }}/>
            </div>
            <div className="vote-pair">
                <img src={`${process.env.PUBLIC_URL}/img/characters/arios.webp`} alt="Arios Key Art" />
                <Button text="Arios" type="solid" onClick={()=>{
                    setVote("Arios")
                    page < 5 ? setPage(page+1) : setPage(5)
                }}/>
            </div>
        </div>
    )
}

const Second = ({setVote, setPage, page}) => {
    return (
        <div className="voting-section">
            <div className="vote-pair">
                <img src={`${process.env.PUBLIC_URL}/img/characters/tio.webp`} alt="Tio Key Art" />
                <Button text="Tio" type="solid" onClick={()=>{
                    setVote("Tio")
                    page < 5 ? setPage(page+1) : setPage(5)
                }}/>
            </div>
            <h1>OR</h1>
            <div className="vote-pair">
                <img src={`${process.env.PUBLIC_URL}/img/characters/wazy.webp`} alt="Wazy Key Art" />
                <Button text="Wazy" type="solid" onClick={()=>{
                    setVote("Wazy")
                    page < 5 ? setPage(page+1) : setPage(5)
                }}/>
            </div>
        </div>
    )
}

const Third = ({setVote, setPage, page}) => {
    return (
        <div className="voting-section">
            <div className="vote-pair">
                <img src={`${process.env.PUBLIC_URL}/img/characters/kea.webp`} alt="KeA Key Art" />
                <Button text="KeA" type="solid" onClick={()=>{
                    setVote("KeA")
                    page < 5 ? setPage(page+1) : setPage(5)
                }}/>
            </div>
            <h1>OR</h1>
            <div className="vote-pair">
                <img src={`${process.env.PUBLIC_URL}/img/characters/dudley.webp`} alt="Dudley Key Art" />
                <Button text="Dudley" type="solid" onClick={()=>{
                    setVote("Dudley")
                    page < 5 ? setPage(page+1) : setPage(5)
                }}/>
            </div>
        </div>
    )
}

const Fourth = ({setVote, setPage, page}) => {
    return (
        <div className="voting-section">
            <div className="vote-pair">
                <img src={`${process.env.PUBLIC_URL}/img/characters/fran.webp`} alt="Fran Key Art" />
                <Button text="Fran" type="solid" onClick={()=>{
                    setVote("Fran")
                    page < 5 ? setPage(page+1) : setPage(5)
                }}/>
            </div>
            <h1>OR</h1>
            <div className="vote-pair">
                <img src={`${process.env.PUBLIC_URL}/img/characters/arios.webp`} alt="Arios Key Art" />
                <Button text="Arios" type="solid" onClick={()=>{
                    setVote("Arios")
                    page < 5 ? setPage(page+1) : setPage(5)
                }}/>
            </div>
        </div>
    )
}

const Fifth = ({canVote, showThanks, vote, setEmail, setName, setWait}) => {
    return (
        <>
            <form className="contest-form" onSubmit={(e)=>{
                e.preventDefault()
                if(canVote) {
                    showThanks(true)
                    vote()
                    ReactGA.event({
                        category: "Recolor Cover",
                        action: "Vote",
                        label: "Submit"
                    })
                }
                else {
                    setWait(true)
                }
            }}>
                <h1>Thank you for voting! You may finish casting your votes by hitting the submit button below.</h1> 
                <h1>Enter your email for a chance to win a <span className="italic">The Legend of Heroes: Trails from Zero</span> 1000-piece Puzzle!</h1>
                <div className="input-pair">
                    <h1>Email:</h1>
                    <input className="email-input" required type="email" placeholder="Enter your Email!" onChange={(e)=>{
                        setEmail(e.target.value)
                    }}/>
                </div>
                <div className="input-pair">
                    <h1>Name:</h1>
                    <input className="email-input" required type="name" placeholder="Enter your Name!" onChange={(e)=>{
                        setName(e.target.value)
                    }}/>
                </div>
                {
                    canVote ? <input type="submit" className="button" value="Submit" 
                    style={{textShadow: '0px 1px rgba(98, 75, 143, 0.5), 0px -1px rgba(98, 75, 143, 0.5), 1px 0px rgba(98, 75, 143, 0.5), -1px 0px rgba(98, 75, 143, 0.5)'}}/> : <h1 className='red-voted'>Your vote has been submitted successfully! <br/> This is the final round of voting.</h1>
                }
            </form>
        </>
    )
}

*/

export default CharacterPoll